import { useTranslation } from "react-i18next";
import { Question } from "@phosphor-icons/react";

export function FaqEmptyState({
  variant,
}: {
  variant: "no-categories" | "no-items" | "no-search";
}) {
  const { t } = useTranslation();

  const copy =
    variant === "no-categories"
      ? { title: t("faqAdmin.empty"), body: t("faqAdmin.emptyCategoriesHint") }
      : variant === "no-search"
        ? { title: t("faqAdmin.emptySearch"), body: t("faqAdmin.emptySearchHint") }
        : { title: t("faqAdmin.noItems"), body: t("faqAdmin.noItemsHint") };

  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-16 text-center">
      <div className="mb-4 flex size-16 items-center justify-center rounded-2xl bg-primary/8">
        <Question className="size-7 text-primary" />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {copy.title}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{copy.body}</p>
    </div>
  );
}
